import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlarmsService } from 'src/app/service/alarms.service';
import { DatePipe } from '@angular/common';
import { ReplaySubject, map, startWith } from 'rxjs';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  standalone: false, // NOSONAR
  encapsulation: ViewEncapsulation.None 
})
export class CreateComponent implements OnInit {

  selectedGroup: any;
  selectedPeriod: any;
  selectedDomiciles = [];
  domicilesArray: any[] = [];
  alarmsGroupsArray: any[] = [];
  periodsArray: any[] = [];
  alarmsJobStatus: string = '';
  alarmsStatsAvaile: boolean = false;
  alarmStats: any;
  strAlarmGroup: any;
  strAlarmPeriod: any;
  alarmStartDate: any;
  alarmEndDate: any;
  pipe: any;
  isGroupSame: boolean = false;
  isPeriodSame: boolean = false;
  isDomicilesSame: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  showResultsButton: boolean = false;
  myGUID: string = '45C278ACB1424F448C96D6F55684D72A';
  guid: string = '';
  groupFilterCtrl: FormControl = new FormControl();
  filteredGroups: ReplaySubject<any[]> = new ReplaySubject(1);
  periodFilterCtrl: FormControl = new FormControl();
  filteredPeriods: ReplaySubject<any[]> = new ReplaySubject(1);
  domicileFilterCtrl: FormControl = new FormControl();
  filteredDomiciles: ReplaySubject<any[]> = new ReplaySubject(1);

  constructor(private readonly alarmsService: AlarmsService, private readonly ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit(): void {
    this.pipe = new DatePipe('en-US');
    this.alarmsService.getPeriods().subscribe(
      result => {
        if (result?.length > 0 && !result?.toString().includes('Fails!')) {
          this.setPeriodsData(result);
        } else {
          console.info('No periods from backend!');
        }
      }
    );

    this.alarmsService.getAlarmGroups().subscribe(
      result => {
        if (result?.length > 0 && !result?.toString().includes('Fails!')) {
          this.setAlarmGroupsData(result);
        } else {
          console.info('No Alarm Groups from backend!');
        }
      }
    );

    this.alarmsService.getDomiciles().subscribe(
      result => {
        if (result?.length > 0 && !result?.toString().includes('Fails!')) {
          this.setDomicilesData(result);
        } else {
          localStorage.setItem('alarmGroups', '');
        }
      }
    );

    this.groupFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterAlarms(search) : this.alarmsGroupsArray.slice())
      )
      .subscribe(filtered => {
        this.filteredGroups.next(filtered);
      });


    this.periodFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterPeriods(search) : this.periodsArray.slice())
      )
      .subscribe(filtered => {
        this.filteredPeriods.next(filtered);
      });

    this.domicileFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterDomiciles(search) : this.domicilesArray.slice())
      )
      .subscribe(filtered => {
        this.filteredDomiciles.next(filtered);
      });
  }

  private filterPeriods(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.periodsArray.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }

  private filterDomiciles(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.domicilesArray.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }

  private filterAlarms(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.alarmsGroupsArray.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }

  formatPeriod(str: string) {
    const arr = str.split('-')
    return arr[1] + '-' + arr[0];
  }

  runAlarmsJob() {
    this.errorMessage = '';
    this.successMessage = '';
    this.alarmStats = '';
    this.alarmsStatsAvaile = false;
    this.validateInput();
    this.guid = localStorage.getItem('toyotaGUID');
    if (this.guid == null || this.guid == '' || this.guid == undefined) {  // NOSONAR
      this.guid = this.myGUID;
    }

    if (this.errorMessage.length == 0) {  // NOSONAR
      localStorage.setItem('selectedAlarmGroup', this.getSelectedAlarmsGroup(this.selectedGroup));
      localStorage.setItem('selectedPeriod', this.formatPeriod(this.getSelectedPeriod(this.selectedPeriod)));
      localStorage.setItem('selectedDomiciles', this.getSelectedDomiciles(this.selectedDomiciles));
      localStorage.setItem('selectedAlarmStartDate', this.getDate(this.alarmStartDate));
      localStorage.setItem('selectedAlarmEndDate', this.getDate(this.alarmEndDate));

      const dataArr = {
        "alarmsGroup": localStorage.getItem('selectedAlarmGroup'),
        "period": localStorage.getItem('selectedPeriod'),
        "domiciles": localStorage.getItem('selectedDomiciles'),
        "alarmStartDate": localStorage.getItem('selectedAlarmStartDate'),
        "alarmEndDate": localStorage.getItem('selectedAlarmEndDate'),
        "guid": this.guid
      }

      console.info("period ", localStorage.getItem('selectedPeriod'));

      this.successMessage = 'Alarms Job is in-progress and you will be receving an email when it completes!';
      this.alarmsService.startAlarmsJob(dataArr).subscribe(
        result => {
          if (result?.length > 0) {
            this.successMessage = '';
            this.alarmsJobStatus = result;
            if (this.alarmsJobStatus == 'Success') {  // NOSONAR
              this.successMessage = 'Alarms Job Executed Successfully.';
              this.getAlarmStats();
            } else {
              this.alarmsStatsAvaile = false;
              this.errorMessage = result;
            }
          } else {
            this.errorMessage = 'Alarms Job not execute!';
          }
        }
      );
    }
  }

  validateInput() {
    if (this.selectedGroup == undefined || this.selectedPeriod == undefined || this.selectedDomiciles.length == 0 || this.alarmStartDate == undefined || this.alarmEndDate == undefined) {  // NOSONAR
      this.errorMessage = 'All the input parameters are mandatory, please select accordingly.';
    }
  }

  onAlarmGroupChange(_event: any) {
    if (this.selectedGroup != undefined && this.selectedPeriod != undefined && this.selectedDomiciles.length > 0) {  // NOSONAR
      this.getAlarmStats();
    }
  }

  onPeriodChange(_event: any) {
     console.info('entered1')
    if (this.selectedGroup != undefined && this.selectedPeriod != undefined && this.selectedDomiciles.length > 0) {  // NOSONAR
      this.getAlarmStats();
    }
  }

  onDomicileChange(_event: any='') {
    console.info('entered')
    if (this.selectedGroup != undefined && this.selectedPeriod != undefined && this.selectedDomiciles.length > 0) {  // NOSONAR
      this.getAlarmStats();
    }
  }

  showStatsButton() {
    if (this.selectedGroup != undefined && this.selectedPeriod != undefined && this.selectedDomiciles.length > 0) {  // NOSONAR
      this.showResultsButton = true;
    }
  }

  getAlarmStats() {
    console.info(this.selectedGroup,"this.selectedGroup")
    console.info(this.selectedPeriod,"this.selectedPeriod")
    console.info(this.selectedDomiciles,"this.selectedDomiciles")
    this.errorMessage = '';
    this.alarmsStatsAvaile = false;
    const dataArr = {
      "alarmsGroup": this.getSelectedAlarmsGroup(this.selectedGroup),
      "period": this.formatPeriod(this.getSelectedPeriod(this.selectedPeriod)),
      "domiciles": this.getSelectedDomiciles(this.selectedDomiciles),
      "alarmStartDate": this.getDate(this.alarmStartDate),
      "alarmEndDate": this.getDate(this.alarmEndDate)
    }

    this.alarmsService.getAlarmStats(dataArr).subscribe(
      result => {
        if (result?.length > 0) {
          this.alarmStats = result;
          this.alarmsStatsAvaile = true;
        } else {
          this.alarmsStatsAvaile = false;
          this.errorMessage = 'Alarms Results not available to display for the selected criteria!';
        }
      }
    );
    this.successMessage = '';
  }

  clear() {
    this.alarmsStatsAvaile = false;
    this.alarmStats = '';
    this.selectedGroup = '';
    this.selectedPeriod = '';
    this.selectedDomiciles = [];
    this.alarmStartDate = '';
    this.alarmEndDate = '';
    this.errorMessage = '';
    this.successMessage = '';
  }

  setPeriodsData(data: any) {
    for (const entry of data) {
      this.periodsArray.push(
        { label: entry, value: entry }
      );
    }

    this.filteredPeriods.next(this.periodsArray.slice());
  }

  setAlarmGroupsData(data: any) {
    for (const entry of data) {
      this.alarmsGroupsArray.push(
        { label: entry, value: entry }
      );
    }

    this.filteredGroups.next(this.alarmsGroupsArray.slice());
  }

  setDomicilesData(data: any) {
    for (const entry of data) {
      this.domicilesArray.push(
        { label: entry, value: entry }
      );
    }
    this.filteredDomiciles.next(this.domicilesArray.slice());
  }

  getSelectedAlarmsGroup(input: any) {
    return JSON.stringify(input, ['value']).substr(10, 1);
  }

  getSelectedPeriod(input: any) {
    return JSON.stringify(input, ['value']).substr(10, 8);
  }

  getSelectedDomiciles(_input: any) {
    let strDomiciles = '';
    this.selectedDomiciles.forEach(element => {
      if (strDomiciles == '') {  // NOSONAR
        strDomiciles = strDomiciles + JSON.stringify(element, ['value']).substr(10, 5);
      } else {
        strDomiciles = strDomiciles + ',' + JSON.stringify(element, ['value']).substr(10, 5);
      }
    });
    return strDomiciles;
  }

  getDate(dt: any) {
    return this.pipe.transform(dt, 'dd-MMM-yy');
  }

  isAllSelected(): boolean {
    return this.selectedDomiciles?.length == this.domicilesArray?.length;  // NOSONAR
  }
  
  isIndeterminate(): boolean {
    return this.selectedDomiciles?.length > 0 &&
           this.domicilesArray?.length > 0 &&
           this.domicilesArray?.length < this.selectedDomiciles?.length;
  }
  
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selectedDomiciles = [...this.domicilesArray];
    } else {
      this.selectedDomiciles = [];
    }
    this.onDomicileChange(); 
  }

}